module.exports = __webpack_public_path__ + "media/images/bg-sequoia-888b0ef460dbaaea884710aac153f717.jpg";